import * as React from "react";
import { renderLeague, renderTeam } from "../../../EventCard/RenderMethods";
export var renderEventTeamsMultiview = function (event, componentPrefix, showLeagueInEventCard) {
    return React.createElement("div", { className: "rj-ev-list__" + componentPrefix + "__section-item rj-ev-list__" + componentPrefix + "__names", "data-uat": "div-ev-list-" + componentPrefix + "-names" },
        renderLeague(showLeagueInEventCard, event.leagueName, componentPrefix),
        renderTeam(event, event.isTeamSwap ? "2" : "1", componentPrefix),
        renderTeam(event, event.isTeamSwap ? "1" : "2", componentPrefix));
};
//# sourceMappingURL=renderEventTeamsMultiview.js.map